// extracted by mini-css-extract-plugin
export var thumbnail = "Video-module--thumbnail--1Aa-4";
export var video = "Video-module--video--_Vo25";
export var showVideo = "Video-module--showVideo--ugpP_";